/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConnectionRequestBasicAuth
 */
export interface ConnectionRequestBasicAuth {
    /**
     * The username to use for the connection.
     * @type {string}
     * @memberof ConnectionRequestBasicAuth
     */
    username: string;
    /**
     * The password to use for the connection.
     * @type {string}
     * @memberof ConnectionRequestBasicAuth
     */
    password: string;
}

/**
 * Check if a given object implements the ConnectionRequestBasicAuth interface.
 */
export function instanceOfConnectionRequestBasicAuth(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "username" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function ConnectionRequestBasicAuthFromJSON(json: any): ConnectionRequestBasicAuth {
    return ConnectionRequestBasicAuthFromJSONTyped(json, false);
}

export function ConnectionRequestBasicAuthFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConnectionRequestBasicAuth {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'username': json['username'],
        'password': json['password'],
    };
}

export function ConnectionRequestBasicAuthToJSON(value?: ConnectionRequestBasicAuth | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'username': value.username,
        'password': value.password,
    };
}

